import { render } from "./footer_culinary.vue?vue&type=template&id=1d26425f"
import script from "./footer_culinary.vue?vue&type=script&lang=js"
export * from "./footer_culinary.vue?vue&type=script&lang=js"

import "./footer_culinary.vue?vue&type=style&index=0&id=1d26425f&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__